/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type {
  TrackingBreadcrumbsFragmentFragment,
  TrackingFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import {
  TrackingBreadcrumbsFragmentFragmentDoc,
  TrackingFragmentFragmentDoc,
} from '@packages/gql/generated/shopping/graphql';
import { getDeterminedAvailabilityDataMock } from './helper/getDeterminedAvailability/mockdata';
import { getGlycerinDisplayProductPayloadDataMock } from './helper/getGlycerinDisplayProductPayload/mockdata';
import { getgetCategoryDataFragmentedData } from './helper/getCategoryData/mockdata';

export const trackingDataMock: TrackingFragmentFragment = {
  ' $fragmentRefs': {
    GetGlycerinDisplayProductPayloadFragmentFragment: getGlycerinDisplayProductPayloadDataMock,
    UseDefaultTrackingFragmentFragment: {} as any,
    GetSizeAndVariantFromDimensionsFragmentFragment: {} as any,
  },
  akl: 'AKLBB761176388',
  sku: 'AKLBB759873585',
  orderNumber: '96692022',
  availability: {
    ...getDeterminedAvailabilityDataMock,
  },
};

export function getTrackingFragmentedData(data?: TrackingFragmentFragment) {
  return makeFragmentData(data || trackingDataMock, TrackingFragmentFragmentDoc);
}

export const trackingBreadcrumbsDataMock: TrackingBreadcrumbsFragmentFragment = {
  ...getgetCategoryDataFragmentedData(),
};

export function getTrackingBreadcrumbsFragmentedData(data?: TrackingBreadcrumbsFragmentFragment) {
  return makeFragmentData(
    data || trackingBreadcrumbsDataMock,
    TrackingBreadcrumbsFragmentFragmentDoc,
  );
}
